module.exports = __webpack_public_path__ + "img/userLicense.8b17ee53.svg";